export const scrollWindowToTop = () => {
  window.scrollTo(0,0);
};